import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classNames from 'classnames/bind';
import styles from "./portal.pcss";
var cn = classNames.bind(styles);

/**
 * Core controller provides base interface for yams ecosystem
 *
 * All user-defined methods must be added by extending this class
 */
export var YamsCoreController = /*#__PURE__*/function () {
  function YamsCoreController() {
    var _this = this;
    _classCallCheck(this, YamsCoreController);
    _defineProperty(this, "_yams", null);
    _defineProperty(this, "_subscribers", []);
    _defineProperty(this, "_detachListeners", null);
    _defineProperty(this, "_isLoaded", false);
    _defineProperty(this, "portalLayout", null);
    _defineProperty(this, "onLoad", function (ymaps) {
      var _window;
      (_window = window).ymaps || (_window.ymaps = ymaps);
      _this._isLoaded = true;
      if (_this._yams) _this._initialize();
    });
    _defineProperty(this, "setMapInstance", function (mapInstance) {
      _this._yams = mapInstance;
    });
    // TODO: Подумать над тем, чтобы добавить предохранитель от повторных инициализаций
    _defineProperty(this, "createPortalContainerLayout", function () {
      return window.ymaps.templateLayoutFactory.createClass("\n      <div\n        class=\"".concat(cn('base'), "\"\n        style=\"width:{{properties.width}};height:{{properties.height}}\"\n        id=\"{{properties.id}}\"\n      />\n    "));
    });
  }
  return _createClass(YamsCoreController, [{
    key: "modules",
    get: function get() {
      return ['templateLayoutFactory'];
    }
  }, {
    key: "inst",
    get: function get() {
      if (!this._yams) throw new Error('Attempting to call yams method when map is not yet mounted');
      return this._yams;
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return !!this._yams && this._isLoaded;
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      this.attachListeners();
      this.portalLayout = this.createPortalContainerLayout();
    }
  }, {
    key: "subscribe",
    value: /** @returns unsubscribe method */
    function subscribe(callback) {
      var _this2 = this;
      this._subscribers.push(callback);
      return function () {
        return _this2._subscribers.filter(function (el) {
          return el !== callback;
        });
      };
    }
  }, {
    key: "attachListeners",
    value: function attachListeners() {
      var _this$_detachListener,
        _this3 = this;
      var _yams = this._yams;

      /** detach previous listeners before attaching new ones */
      (_this$_detachListener = this._detachListeners) === null || _this$_detachListener === void 0 || _this$_detachListener.call(this);
      var handleBoundsChange = function handleBoundsChange() {
        if (!_yams) return;
        _this3._notifySubscribers();
      };
      _yams === null || _yams === void 0 || _yams.events.add('boundschange', handleBoundsChange);
      this._detachListeners = function () {
        return _yams === null || _yams === void 0 ? void 0 : _yams.events.remove('boundschange', handleBoundsChange);
      };
      this._notifySubscribers();
    }
  }, {
    key: "_notifySubscribers",
    value: function _notifySubscribers() {
      var _yams = this._yams;
      this._subscribers.forEach(function (callback) {
        return callback(_yams);
      });
    }
  }]);
}();